import React, { ComponentProps, forwardRef } from 'react';

import { useInstanceId } from '@adsk/alloy-react-helpers';
import { Icon, IconWithRender } from '@adsk/alloy-react-icon';

type AvatarIconProps = ComponentProps<typeof Icon> & {
  /**
   * Background color for the avatar circle.
   * @default '#bbbbbb'
   */
  backgroundColor?: string;
  /**
   * Icon/silhouette color.
   * @default '#000000'
   */
  iconColor?: string;
};

const AVATAR_ICON_BACKGROUND = '#bbbbbb';
const AVATAR_ICON_COLOR = '#000000';

const AvatarIcon = forwardRef<SVGSVGElement, AvatarIconProps>(
  (
    {
      style,
      backgroundColor = AVATAR_ICON_BACKGROUND,
      iconColor = AVATAR_ICON_COLOR,
      ...props
    },
    ref,
  ) => {
    const instanceId = useInstanceId();
    const clipPathId = `weaveAvatarClip-${instanceId}`;

    return (
      <Icon
        data-testid="weavePerson"
        ref={ref}
        viewBox="0 0 64 64"
        style={[{ width: '100%', height: '100%' }, style]}
        {...props}
      >
        <g clipPath={`url(#${clipPathId})`}>
          <rect width="64" height="64" rx="32" fill={backgroundColor} />
          <path
            fill={iconColor}
            opacity={0.5}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M36.0297 38.1579L38.9694 35.3702C41.1053 33.3447 42.5 30.3724 42.5 27C42.5 20.5296 37.5095 15.8 32 15.8C26.4905 15.8 21.5 20.5296 21.5 27C21.5 30.3724 22.8947 33.3447 25.0306 35.3702L27.9703 38.1579L24.1951 39.8565C18.1565 42.5734 14 48.3364 14 55V66.2H50V55C50 48.3364 45.8435 42.5734 39.8049 39.8565L36.0297 38.1579ZM20.2221 38.7705C14.6566 42.2957 11 48.2493 11 55V69H53V55C53 48.2493 49.3434 42.2957 43.7779 38.7705C42.93 38.2335 42.0379 37.7528 41.1076 37.3342C41.8175 36.661 42.4579 35.9101 43.0161 35.0945C44.5804 32.8091 45.5 30.0159 45.5 27C45.5 19.268 39.4558 13 32 13C24.5442 13 18.5 19.268 18.5 27C18.5 30.0159 19.4196 32.8091 20.9839 35.0945C21.5421 35.9101 22.1825 36.661 22.8924 37.3342C21.9621 37.7528 21.07 38.2335 20.2221 38.7705Z"
          />
        </g>
        <defs>
          <clipPath id={clipPathId}>
            <rect width="64" height="64" rx="32" />
          </clipPath>
        </defs>
      </Icon>
    );
  },
) as IconWithRender;

AvatarIcon.displayName = 'AvatarIcon';
AvatarIcon.renderIcon = (props) => <AvatarIcon {...props} />;
AvatarIcon.propTypes = Icon.propTypes;
export default AvatarIcon;
